export default "__VITE_ASSET__da2b0fe9__"